var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuePlus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(0.38948954,0,0,0.38948954,-31.938997,-55.106522)",
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "matrix(2.0678171,0,0,2.0678171,97.581635,10.615336)",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#449d29",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.777066,91.559368 7.4134761,100.42389 c -0.3448244,0.26899 -0.8415613,0.20765 -1.1105736,-0.1372 L -4.2137066,86.805257 c -0.2689911,-0.344825 -0.2076466,-0.841561 0.137205,-1.110573 L 7.2870885,76.830161 4.6427331,73.440315 C 4.3737421,73.09549 4.4350866,72.598753 4.7799382,72.329741 4.9433354,72.202278 5.1425907,72.149246 5.3342942,72.165248 l 21.7175508,0.313063 c 0.436459,0.006 0.784313,0.364408 0.778341,0.800866 -1.45e-4,0.06326 -0.0095,0.123465 -0.02452,0.182971 L 22.813739,94.64485 c -0.100419,0.424793 -0.523988,0.686944 -0.949848,0.587359 -0.181699,-0.04259 -0.334922,-0.144926 -0.441695,-0.281799 l -2.645414,-3.38902 z",
    fillRule: "evenodd",
    id: "path1-1",
    style: {
      strokeWidth: 0.344492,
      stroke: "none",
      strokeOpacity: 1,
      fill: "#449d29",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuePlus2);
export default __webpack_public_path__ + "static/media/value-plus2.bb76730c78973950edb92735cf6f3a17.svg";
export { ForwardRef as ReactComponent };